import { Grid } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TopPage from 'v2/components/Shared/TopPage';
import { EProductType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { ButtonRedirect } from './ButtonRedirect';

import type { DispatchProp } from 'react-redux';

function SinglePaymentIcon() {
  return (
    <svg width='25' height='23' viewBox='0 0 25 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.125 4.6875C3.125 5.11897 3.47478 5.46875 3.90625 5.46875H21.0938C21.5252 5.46875 21.875 5.11897 21.875 4.6875C21.875 4.25603 21.5252 3.90625 21.0938 3.90625H3.90625C3.47478 3.90625 3.125 4.25603 3.125 4.6875Z'
        fill='#FFBC00'
      />
      <path
        d='M6.25 1.5625C6.25 1.99397 6.59978 2.34375 7.03125 2.34375H17.9688C18.4002 2.34375 18.75 1.99397 18.75 1.5625C18.75 1.13103 18.4002 0.78125 17.9688 0.78125H7.03125C6.59978 0.78125 6.25 1.13103 6.25 1.5625Z'
        fill='#FFBC00'
      />
      <path
        d='M10.5703 10.275C10.3295 10.1245 10.0259 10.1165 9.77752 10.2542C9.52912 10.3919 9.375 10.6535 9.375 10.9375V18.75C9.375 19.034 9.52912 19.2956 9.77752 19.4333C10.0259 19.571 10.3295 19.563 10.5703 19.4125L16.8203 15.5062C17.0487 15.3635 17.1875 15.1131 17.1875 14.8437C17.1875 14.5744 17.0487 14.324 16.8203 14.1812L10.5703 10.275Z'
        fill='#FFBC00'
      />
      <path
        d='M2.34375 22.6562C1.04933 22.6562 0 21.6069 0 20.3125V9.375C0 8.08058 1.04933 7.03125 2.34375 7.03125H22.6562C23.9507 7.03125 25 8.08058 25 9.375V20.3125C25 21.6069 23.9507 22.6562 22.6562 22.6562H2.34375ZM22.6562 21.0937C23.0877 21.0937 23.4375 20.744 23.4375 20.3125V9.375C23.4375 8.94353 23.0877 8.59375 22.6562 8.59375H2.34375C1.91228 8.59375 1.5625 8.94353 1.5625 9.375V20.3125C1.5625 20.744 1.91228 21.0937 2.34375 21.0937H22.6562Z'
        fill='#FFBC00'
      />
    </svg>
  );
}

function SubscriptionIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.6352 1.01007C15.9403 0.704976 16.435 0.704976 16.7401 1.01007L22.9901 7.26007C23.2952 7.56517 23.2952 8.05983 22.9901 8.36493L20.0181 11.3369L18.7237 16.5147C18.5232 17.3167 17.9151 17.9537 17.1234 18.1912L0.959961 23.0402L5.80898 6.87681C6.0465 6.08507 6.68352 5.47699 7.48544 5.27651L12.6633 3.98206L15.6352 1.01007ZM12.823 5.55271L7.86441 6.79236C7.5971 6.85919 7.38476 7.06188 7.30558 7.32579L3.29039 20.7098L16.6744 16.6946C16.9383 16.6154 17.141 16.4031 17.2078 16.1358L18.4475 11.1771L12.823 5.55271Z'
        fill='#FFBC00'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.4251 20.6694L11.5002 14.0625C12.3632 14.0625 13.0627 13.3629 13.0627 12.5C13.0627 11.6371 12.3632 10.9375 11.5002 10.9375C10.6373 10.9375 9.93775 11.6371 9.93775 12.5L3.33079 20.5751L3.29039 20.7098L3.4251 20.6694Z'
        fill='#FFBC00'
      />
    </svg>
  );
}

function ServiceIcon() {
  return (
    <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.25 24C6.25 24 4.6875 24 4.6875 22.4375C4.6875 20.875 6.25 16.1875 12.5 16.1875C18.75 16.1875 20.3125 20.875 20.3125 22.4375C20.3125 24 18.75 24 18.75 24H6.25Z'
        fill='#FFBC00'
      />
      <path
        d='M12.5 14.7031C14.6574 14.7031 16.4062 12.9543 16.4062 10.7969C16.4062 8.63953 14.6574 6.89064 12.5 6.89064C10.3426 6.89064 8.59375 8.63953 8.59375 10.7969C8.59375 12.9543 10.3426 14.7031 12.5 14.7031Z'
        fill='#FFBC00'
      />
      <path
        d='M3.125 0.5625C1.39911 0.5625 0 1.96161 0 3.6875V18.5312C0 19.8257 1.04933 20.875 2.34375 20.875H3.36387C3.63776 19.8961 4.16419 18.7725 5.02934 17.75H1.5625V3.6875C1.5625 2.82455 2.26206 2.125 3.125 2.125H21.875C22.7379 2.125 23.4375 2.82456 23.4375 3.6875V17.75H19.9707C20.8358 18.7725 21.3622 19.8961 21.6361 20.875H22.6562C23.9507 20.875 25 19.8257 25 18.5312V3.6875C25 1.96161 23.6009 0.5625 21.875 0.5625H3.125Z'
        fill='#FFBC00'
      />
    </svg>
  );
}

function EventsIcon() {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.2868 25C18.7964 25 24.0735 19.4036 24.0735 12.5C24.0735 5.59644 18.7964 0 12.2868 0C5.77711 0 0.5 5.59644 0.5 12.5C0.5 19.4036 5.77711 25 12.2868 25Z'
        fill='#FFBC00'
      />
      <path
        d='M0.5 6.29395H24.5V8.82573C22.807 9.08834 21.5662 10.6662 21.5662 12.5001C21.5662 14.3342 22.8129 15.9109 24.5 16.1743V18.7063H0.5V16.1976C2.28628 16.0247 3.61765 14.3998 3.61765 12.5001C3.61765 10.6001 2.27962 8.97616 0.5 8.80272V6.29395Z'
        fill='white'
        stroke='#FFBC00'
      />
      <path d='M5.61765 6.48779H4.75V8.48405H5.61765V6.48779Z' fill='#FFBC00' />
      <path d='M5.61765 9.66943H4.75V11.6657H5.61765V9.66943Z' fill='#FFBC00' />
      <path d='M5.61765 13.124H4.75V15.1203H5.61765V13.124Z' fill='#FFBC00' />
      <path d='M5.61765 16.5391H4.75V18.5353H5.61765V16.5391Z' fill='#FFBC00' />
      <path d='M20.6689 6.48779H19.8013V8.48405H20.6689V6.48779Z' fill='#FFBC00' />
      <path d='M20.6689 9.66943H19.8013V11.6657H20.6689V9.66943Z' fill='#FFBC00' />
      <path d='M20.6689 13.124H19.8013V15.1203H20.6689V13.124Z' fill='#FFBC00' />
      <path d='M20.6689 16.5391H19.8013V18.5353H20.6689V16.5391Z' fill='#FFBC00' />
    </svg>
  );
}

function PhysicalIcon() {
  return (
    <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.7901 1.73898C12.6039 1.66448 12.3961 1.66448 12.2099 1.73898L2.88483 5.46899L6.64062 6.97131L16.2558 3.12524L12.7901 1.73898ZM18.3594 3.96667L8.7442 7.81274L12.5 9.31506L22.1152 5.46899L18.3594 3.96667ZM23.4375 6.62292L13.2812 10.6854V23.0651L23.4375 19.0026V6.62292ZM11.7188 23.0651V10.6854L1.5625 6.62292V19.0026L11.7188 23.0651ZM11.6296 0.288238C12.1883 0.0647279 12.8117 0.0647279 13.3704 0.288238L24.5089 4.74362C24.8055 4.86226 25 5.14953 25 5.46899V19.0026C25 19.6415 24.611 20.216 24.0178 20.4533L12.7901 24.9444C12.6039 25.0189 12.3961 25.0189 12.2099 24.9444L0.982202 20.4533C0.388986 20.216 0 19.6415 0 19.0026V5.46899C0 5.14953 0.194493 4.86226 0.491101 4.74362L11.6296 0.288238Z'
        fill='#FFBC00'
      />
    </svg>
  );
}

const products = [
  {
    id: 'new-subscription-button',
    title: 'Assinatura',
    subtitle: 'Crie cobranças recorrentes através de planos de assinaturas.',
    type: EProductType.SUBSCRIPTION,
    icon: <SubscriptionIcon />,
    betaModule: 'planos_assinatura',
    isNew: true,
  },
  {
    id: 'new-info-product-button',
    title: 'Digital',
    subtitle: 'Cadastre um infoproduto. E-books, cursos online, planilhas… ',
    icon: <SinglePaymentIcon />,
    type: EProductType.DIGITAL,
  },
  {
    id: 'new-physical-product-button',
    title: 'Produto físico para envio',
    subtitle: 'Livros, apostilas, brindes, premiações, objetos com frete...',
    icon: <PhysicalIcon />,
    type: EProductType.PHYSICAL,
  },
  {
    id: 'new-jobzz-product-button',
    icon: <ServiceIcon />,
    title: 'Serviço online',
    subtitle: 'Cadastre suas consultorias dedicadas, mentorias, coaching, bate-papo...',
    type: EProductType.SERVICE,
  },
  {
    id: 'new-blinket-product-button',
    icon: <EventsIcon />,
    title: 'Eventos',
    subtitle: 'Congressos, workshops, shows, eventos presencias, mentorias em grupo, palestras...',
    type: EProductType.TICKET,
    redirect: 'https://app.blinket.com.br/event?utm_source=orbita&utm_medium=newproduct',
  },
];

interface IProps extends DispatchProp<any> {}

interface IStates {
  productCard: typeof products;
}

class StepOne extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      productCard: products,
    };
  }

  componentDidMount() {
    let productCards = this.state.productCard;
    this.setState({ productCard: productCards });
  }

  onChooseType = async (selected: (typeof products)[0]) => {
    if (selected.type === EProductType.TICKET) {
      window.open(selected.redirect, '_blank');
      return;
    }
    try {
      await this.props.dispatch({ type: 'SET_VALUE_WIZARD_NP', value: selected.type });
      this.props.dispatch({ type: 'NEXT_STEP_WIZARD_NP' });

      if (!selected.type) {
        return;
      }

      const url = EProductType[selected.type]?.toLowerCase() as Lowercase<keyof typeof EProductType>;
      this.setUrlHistory(url);
    } catch (error) {}
  };

  setUrlHistory = (url: Lowercase<keyof typeof EProductType>) => {
    const currentUrl = window.location.href;
    if (url && !currentUrl.includes(url)) {
      window.history.replaceState(null, null, `${currentUrl}/${url}`);
    }
  };

  render() {
    const hasPlansBetaModule = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');
    return (
      <div>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid item xs={12}>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link to='/producer/product/myproducts'>Meus Produtos</Link>
              <p>Tipo de produto</p>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <TopPage title='Novo produto' />

        <Grid container spacing={2}>
          {products.map((product) => {
            if (product.betaModule && !eduzzAccountsService.verifyUserHasBetaModule(product.betaModule)) return null;
            if (hasPlansBetaModule && product.type === EProductType.DIGITAL) {
              product.title = 'Cobrança única';
            }
            return (
              <Grid item xl={3} lg={4} sm={6} xs={12} key={product.title}>
                <ButtonRedirect {...product} onClick={() => this.onChooseType(product)} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  }
}

export default connect()(StepOne);
